export const SIDEBAR_CLOSE = '@@navigation/SIDEBAR_CLOSE',
    SIDEBAR_OPEN = '@@navigation/SIDEBAR_OPEN',
    SIDEBAR_TOGGLE = '@@navigation/SIDEBAR_TOGGLE',
    sidebarClose = () => ({type: SIDEBAR_CLOSE}),
    sidebarOpen = () => ({type: SIDEBAR_OPEN}),
    sidebarToggle = () => ({type: SIDEBAR_TOGGLE});


// WEBPACK FOOTER //
// ./src/actions/navigation.js